import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
//import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics/ngx';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { Platform } from '@ionic/angular';

import { take, tap } from 'rxjs/operators';
import { UnrApiService } from './core/api/api.service';
import { UnrAuthService } from './core/auth/auth.service';
import { LoginPageStateService } from './pages/login/login-page-state.service';
import { UnrSettingsService } from './services/settings/settings.service';
import { FacebookAuthProvider , GoogleAuthProvider} from 'firebase/auth';
import {
  AuthProviderId,
  AuthProviders,
} from './core/auth/enum/auth-providers.enum';
import { UserRegistration } from './core/api/resources/user-registration.resource';
import { User } from '@angular/fire/auth';
import { register } from 'swiper/element/bundle';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { SwUpdate } from '@angular/service-worker';
register();
declare var hello: any;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  @ViewChild('menu', { static: false }) menu: any;
  constructor(
    private authService: UnrAuthService,
    private platform: Platform,
    public router: Router,
    private unrAuthService: UnrAuthService,
    public ngZone: NgZone,
    private api: UnrApiService,
    private settings: UnrSettingsService,
    //private googleAnalytics: GoogleAnalytics,
    public afAuth: AngularFireAuth,
    private swUpdate: SwUpdate,
    private screenOrientation: ScreenOrientation,
    private loginPageStateService: LoginPageStateService
  ) {
     if (this.swUpdate.isEnabled) {
    this.swUpdate.versionUpdates.subscribe(() => {
      window.location.reload();
    });
  }
        // Check for redirect result first, before any other auth operations
   hello.init(
  {
    facebook: 747858448892921
  },
  { redirect_uri: window.location.origin + '/' }
);
   
    this.authService.getUid2().then((res: any) => {
      if (res?.uid) {
        localStorage.setItem('uid', res.uid);
      }
    });

    setInterval(() => {
      this.authService.getUid2().then((res: any) => {
        if (res?.uid) {
          localStorage.setItem('uid', res.uid);
        } else {
          localStorage.removeItem('uid');
        }
      });
    }, 1000);
  }
  goToTrips(): void {
    this.router.navigate(['roadtrips']);
  }

  goToProfile(): void {
    this.router.navigate(['profile']);
  }

  goToTripRecorder(): void {
    this.router.navigate(['triprecorder']);
  }

  goToRecordedTrips(): void {
    this.router.navigate(['triprecorder', 'recorded-trips']);
  }

  async logout(): Promise<void> {
    await this.menu.toggle();
    await this.unrAuthService.signOut();
    await this.router.navigate(['']);
  }

  async ngOnInit(): Promise<void> {
    if(localStorage.getItem('fbloginst') == 'yes'){
      await this.authService.showLoadingIndicator();
    }
    // Check for redirect result first, before any other auth operations
hello.on('auth.login', async (auth: any) => {
  this.ngZone.run(async () => {   // ensures Angular change detection
    console.log('FB login after redirect:', auth);

    try {
      const fbUser = await hello('facebook').api('me');
      console.log('FB User:', fbUser);
      localStorage.setItem('fb_user', JSON.stringify(fbUser));

      const accessToken = auth.authResponse.access_token;
      const credential = FacebookAuthProvider.credential(accessToken);

      const firebaseUser = await this.afAuth.signInWithCredential(credential);
      console.log('Firebase login complete:', firebaseUser.user?.uid);

    // Wait a tick to ensure Angular is ready for navigation
      setTimeout(async () => {
        await  this.unrAuthService.setupPostLogin().then(async () => {
           localStorage.removeItem('fbloginst');
          this.authService.hideLoadingIndicator();
        if (this.settings.getShowWelcomeScreen()) {
         
          this.router
            .navigate(['welcome'], { skipLocationChange: true });
        } else {
          this.router
            .navigate(['roadtrips'], { skipLocationChange: true });
        }
      }).catch((err) => {
        console.error('Post-login setup failed:', err);
        this.router.navigate(['']);
      });
      }, 100);  // 100ms is usually enough
    } catch (err) {
      console.error('Firebase login with FB token failed', err);
    }
  });
});

    this.afAuth.getRedirectResult().then((res: any) => {

      console.log("🔄 Redirect result:", res);
      
      if (res?.user) {
        console.log("🔄 Redirect login success:", res.user);

      // Detect provider from user's providerData
      let providerId = AuthProviderId.Google;
      let providerName = AuthProviders.Google;
      
      if (res.user.providerData && res.user.providerData.length > 0) {
        const providerData = res.user.providerData[0];
        if (providerData.providerId === 'facebook.com') {
          providerId = AuthProviderId.Facebook;
          providerName = AuthProviders.Facebook;
        } else if (providerData.providerId === 'google.com') {
          providerId = AuthProviderId.Google;
          providerName = AuthProviders.Google;
        }
      }

      // Set the auth provider
      this.unrAuthService.authProvider.next({
        id: providerId,
        name: providerName,
        firebaseProvider: null
      });

      // Then run your normal post-login flow
      this.unrAuthService.setupPostLogin().then(() => {
        if (this.settings.getShowWelcomeScreen()) {
          this.router
            .navigate(['welcome'], { skipLocationChange: true });
        } else {
          this.router
            .navigate(['roadtrips'], { skipLocationChange: true });
        }
      }).catch((err) => {
        console.error('Post-login setup failed:', err);
        this.router.navigate(['']);
      });
      } else if (res?.error) {
        console.error('Redirect error:', res.error);
      }
    }).catch((err) => {
      console.error('Error getting redirect result:', err);
    });
    this.setAndroidBackButtonBehavior();
    this.platform
      .ready()
      .then(() =>
        this.screenOrientation.lock(
          this.screenOrientation.ORIENTATIONS.PORTRAIT
        )
      )
      .then(() => this.setGoogleAnalytics())
      .then(() => this.checkUserIsLoggedIn())
      .then((authState) => this.registerUserAndSetKmOrMiles(authState))
      .then((authState) => this.unrAuthService.setUid(authState.uid))
      .catch(() => this.router.navigate(['']));
  }

  private checkUserIsLoggedIn(): Promise<User> {
    return this.unrAuthService
      .getAuthState()
      .pipe(
        tap((authState: User) => {
          if (authState !== null && authState !== undefined) {
            if (authState.providerData[0]) {
              if (authState.providerData[0].providerId === 'apple.com') {
                this.unrAuthService.authProvider.next({
                  id: AuthProviderId.Apple,
                  name: AuthProviders.Apple,
                  firebaseProvider: null,
                });
              }
            }
          }
        }),
        take(1)
      )
      .toPromise()
      .then((authState) => {
        return authState === null
          ? Promise.reject('User is logged out')
          : Promise.resolve(authState);
      });
  }

  private setGoogleAnalytics(): Promise<string> {
    return 
    // this.googleAnalytics
    //   .startTrackerWithId('UA-130056688-1', 30)
    //   .catch((err) => {
    //     console.error('Could not set google analytics', err);
    //   });
  }

  private setAndroidBackButtonBehavior(): void {
    if (this.platform.is('android')) {
      this.platform.backButton.subscribe(() => {
        if (
          window.location.pathname === '/roadtrips/list' ||
          window.location.pathname === '/roadtrips/map' ||
          window.location.pathname === '/'
        ) {
          if (!this.loginPageStateService.getIsModalViewOpen()) {
            navigator['app'].exitApp();
          }
        }
      });
    }
  }

  private registerUserAndSetKmOrMiles = (authState) =>
    this.api
      .registerUser(authState.email)
      .pipe(take(1))
      .toPromise()
      .then((payload: UserRegistration) => {
        this.settings.setAllSettings(payload.settings);
        return authState;
      })
      .catch((err) => {
        return authState;
      });
}
